export default "__VITE_ASSET__Vr0Ar_e6__"